import { z } from 'zod';
import { PackageCategoryQuotes } from '@pages/Electrify2515/PackageCategoryQuotes';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/electrify2515/$category')({
  component: PackageCategoryQuotes,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
